
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRangeRingsIec as ObiRangeRingsIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-range-rings-iec.js';
 
 
 

 
 export const ObiRangeRingsIec = createComponent({
   react: React,
   tagName: 'obi-range-rings-iec',
   elementClass: ObiRangeRingsIecElement,
   events: {
     
   }
  });
 
 